/* eslint-disable */
const state = {
  isFromApp: false, // 营销玩法页面是否是从app页面直接进入
  inputTimerScroll: null,
  inputTextReg: /[^\d\w\u4E00-\u9FA5，。？！……～#：：、“”‘’（）\-；@*_~%&·•//,〈〉『』〔〕【】+−×÷=^!._@//?#!~…:;$%^&*()-+=“”‘’•|]/g, // 文本输入框检验正则表达式
  inputTextWithoutChineseReg: /[^\d，。？！……～#：：、“”‘’（）\-；@*_~%&·•//,〈〉『』〔〕【】+−×÷=^!._@//?#!~…:;$%^&*()-+=“”‘’•|]/g, // 数字 和 符号 输入正则表达式
}

const mutations = {
  setInputTimerScroll (state, value) {
    state.inputTimerScroll = value
  },
  clearInputTimerScroll (state) {
    clearTimeout(state.inputTimerScroll)
  },
  setIsFromApp (state, value) {
    state.isFromApp = value
  }
}
const getters = {
  getTextReg: state => state.inputTextReg,
  getNumReg: state => state.inputTextWithoutChineseReg,
  getIsFromApp: state => state.isFromApp
}

export default {
  state,
  getters,
  mutations
}
